import { UnfoldLess } from '@mui/icons-material'
import { CircularProgress, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material'

type SearchGroupHeaderProps = {
  label: string
  /** Whether the group lists every match rather than its first few. */
  isExpanded: boolean
  isLoading: boolean
  /** The group's match count, shown once it is expanded. */
  resultCount: number
  /** Tooltip and accessible name of the collapse control. */
  collapseLabel: string
  /** Folds an expanded group back to its first few matches; omit to hide the control. */
  onCollapse?: () => void
}

/**
 * The heading over one kind's results in a grouped entity search: the kind's
 * name, a spinner while it loads, its count once expanded, and a rule running
 * to the collapse control.
 */
export default function SearchGroupHeader({
  label,
  isExpanded,
  isLoading,
  resultCount,
  collapseLabel,
  onCollapse
}: SearchGroupHeaderProps) {
  return (
    <Stack direction="row" alignItems="center" gap={2} px={4} py={1} sx={{ bgcolor: 'background.paper' }}>
      <Typography variant="overline" fontWeight={600}>
        {label}
      </Typography>
      {isLoading && <CircularProgress size={14} />}
      {isExpanded && (
        <Typography variant="caption" color="text.secondary">
          ({resultCount})
        </Typography>
      )}
      <Divider sx={{ flex: 1 }} />
      {isExpanded && onCollapse && (
        <Tooltip title={collapseLabel}>
          <IconButton size="small" aria-label={collapseLabel} onClick={onCollapse} sx={{ p: 0.5 }}>
            <UnfoldLess fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  )
}
